<template>
  <div class="menu-containter">
  
    <el-menu
      :default-active="menuActive"
      :default-openeds="openKeys"
      :unique-opened="true"
      class="el-menu-vertical-demo"
      background-color="rgba(0,0,0,0)"
      text-color="#fff"
      active-text-color="rgb(64, 158, 255)"
      @select="handleMenuSelect"
    >
      <menu-item v-for="item in menuList" :key="item.index" :item="item" />
    </el-menu>
  </div>
  </template>
<script>

  // 递归渲染菜单，支持最多三级（更深也可）
  const MenuItem = {
    name: 'MenuItem',
    functional: true,
    props: {
      item: { type: Object, required: true }
    },
    render(h, { props }) {
      const item = props.item
      const hasChildren = Array.isArray(item.children) && item.children.length > 0
      if (hasChildren  ) {
        return h(
          'el-submenu',
          { props: { index: item.path } },
          [
            h('template', { slot: 'title' }, [
              item.icon ? h('i', { class: item.icon }) : null,
              h('span', [item.menuName])
            ]),
            ...item.children.map(child => h(MenuItem, { props: { item: child }, key: child.index }))
          ]
        )
      }
      // 叶子结点：使用 index 作为 index，确保与 el-submenu 的 index 一致
      if( item.menuType != 'F' ){
        return h(
          'el-menu-item',
          { props: { index: item.path } },
          [
            item.icon ? h('i', { class: item.icon }) : null,
            h('span', [item.menuName])
          ]
        )
      }
      
    }
  }
  import { $menu  } from "@/services/admin";
  export default {
    name: 'AdminMenu',
    components: { MenuItem },
    data() {
      return {
        // 示例菜单：演示 1/2/3 级
        menuList:[],
        // menuList: [
        //   { menuName: '首页', path: '/admin', index: '1', icon: 'el-icon-menu' },
        //   {
        //     menuName: '系统管理', index: '2', icon: 'el-icon-setting', children: [
        //       { menuName: '角色管理', path: '/admin/role', index: '2-1', icon: 'el-icon-user' },
        //       { menuName: '菜单管理', path: '/admin/menu', index: '2-2', icon: 'el-icon-menu' },
        //       { menuName: '用户管理', path: '/admin/account', index: '2-3', icon: 'el-icon-menu' },
             
        //     ]
        //   },
        //   {
        //     menuName: '示例', index: '3', icon: 'el-icon-document', children: [
        //       { menuName: '示例一', path: '/admin/example1', index: '3-1' },
        //       { menuName: '示例二', path: '/admin/example2', index: '3-2' }
        //     ]
        //   }
        // ],
        openKeys: []
      }
    },
    computed: {
      // 使用当前路由路径作为激活项，刷新后会自动高亮
      menuActive() {
        return this.$route.path
      }
    },
    watch: {
      '$route.path': {
        immediate: true,
        handler(newPath) {
          this.openKeys = this.computeOpenKeysByPath(this.menuList, newPath)
          console.log( this.openKeys )
        }
      },
      // 监听菜单数据变化，重新计算展开的菜单项
      menuList: {
        handler(newMenuList) {
          if (newMenuList && newMenuList.length > 0) {
            this.openKeys = this.computeOpenKeysByPath(newMenuList, this.$route.path)
          }
        },
        deep: true
      }
    },
    created(){
      this.getMenuList()
    },
    methods: {
      async getMenuList(){
        let res = await $menu.menuList({ status:0 , menuApplyCode:0 })
        if( res.code == 200 ){
          let data = [];
          for ( const element of res.data ) {
            if( element.menuType != 'F' ){
              data.push( element )
            }
          }
          this.menuList = this.handleTree( data , "menuId");
          // 为每个菜单项添加index属性
          this.addIndexToMenu(this.menuList);
        }
      },
      // 为菜单项添加index属性
      addIndexToMenu(menuList, parentIndex = '' , path ) {
        menuList.forEach((item, index) => {
          // 生成唯一的index值
          const currentIndex = parentIndex ? `${parentIndex}-${index + 1}` : `${index + 1}`;
          item.index = currentIndex;
          if( path )
            item.path = '/'+path+'/'+item.path;
          // 如果有子菜单，递归处理
          if (item.children && item.children.length > 0) {

            this.addIndexToMenu(item.children, currentIndex ,item.path );
          }
        });
      },
      // 计算需要展开的父级 submenu 索引数组
      computeOpenKeysByPath(list, path) {
        const stack = []
        let found = false

        const dfs = (nodes, parents) => {
          if (!nodes || found) return
          for (const node of nodes) {
            if (node.children && node.children.length) {
              parents.push(node.path)
              dfs(node.children, parents)
              if (found) return
              parents.pop()
            } else if (node.path === path) {
              found = true
              return
            }
          }
        }

        dfs(list, stack)
        // 返回副本，避免外部修改内部栈
        return [...stack]
      },
      handleMenuSelect(index) {
        this.$router.push({ path: index });
      }
    }
  }
  </script>
<style lang="less" >
.menu-containter{
    .el-submenu__title{
        display: flex;
        justify-content: flex-start;
        align-items: center;
        &:hover{
            background: linear-gradient(to right, rgba(67,116,248) 0%, rgb(121,215,211) 100%) !important;
        }
    }
    .el-menu-item {
        display: flex;
        justify-content: flex-start;
        align-items: center;
        &:hover{
            background: linear-gradient(to right, rgba(67,116,248) 0%, rgb(121,215,211) 100%) !important;
        }
    }
}
</style>